import React, { useRef } from 'react';

import CookieConsent from 'react-cookie-consent';
import { Box, Typography } from '@mui/material';

import { preLoginLang } from '@pharmaplan/common';

import CustomButton from '../common/CustomButton';
import { useAppSelector } from '../../hooks/useAppSelector';
import useAnalyticsConsent from '../../hooks/Consent/useAnalyticsConsent';
import { ReactComponent as CookieIcon } from '../../assets/svg/cookieIcon.svg';
import strings from '../../localization';
import { Constants } from '../../helpers/Constants';
import { COOKIE_CONSENT_NAME } from '../../helpers/cookieConsent';

import classes from './style';
import './style.css';

const {
  cookieConsentExpiryDays,
  paths: { staticPages },
  variant: { outlined },
} = Constants;

const {
  displayNone,
  content,
  contentContainer,
  contentSubContainer,
  textContainer,
  privacyPolicyText,
  heading,
  headingContainer,
  button,
  buttonsContainer,
  refuseButton,
  acceptButton,
} = classes;

const CookiePrompt = () => {
  const cookieConsentRef = useRef<CookieConsent | null>(null);
  const userLanguage = useAppSelector(preLoginLang);
  const { handleAccept, handleDecline } = useAnalyticsConsent();

  const { privacyPolicy } = staticPages[userLanguage as keyof typeof staticPages];

  const handleOnClick = () => {
    if (cookieConsentRef.current) {
      cookieConsentRef.current.accept();
    }
  };

  const handleRefuseClick = () => {
    if (cookieConsentRef.current) {
      cookieConsentRef.current.decline();
    }
  };

  return (
    <CookieConsent
      ref={cookieConsentRef}
      cookieName={COOKIE_CONSENT_NAME}
      expires={cookieConsentExpiryDays}
      onAccept={handleAccept}
      onDecline={handleDecline}
      buttonStyle={displayNone}
      overlay
      contentClasses="content-container"
      containerClasses="container"
    >
      <Box sx={contentContainer}>
        <Box sx={headingContainer}>
          <CookieIcon />
          <Typography sx={heading}>{strings.usesCookie}</Typography>
        </Box>

        <Box sx={contentSubContainer}>
          <Box sx={textContainer}>
            <Typography sx={content}>
              {strings.cookieConsent}
              <Typography
                component="a"
                sx={[content, privacyPolicyText]}
                href={privacyPolicy}
                target="_blank"
              >
                {strings.privacyPolicy}
              </Typography>
              .
            </Typography>
          </Box>

          <Box sx={buttonsContainer}>
            <CustomButton
              customClass={button}
              customButtonStyle={refuseButton}
              variant={outlined}
              label={strings.rejectNonEssentialCookies}
              onClick={handleRefuseClick}
            />
            <CustomButton
              customClass={button}
              customButtonStyle={acceptButton}
              label={strings.acceptCookies}
              onClick={handleOnClick}
            />
          </Box>
        </Box>
      </Box>
    </CookieConsent>
  );
};

export default CookiePrompt;
